import React from "react";
import { throttle } from "lodash";
import * as queryString from "query-string";
import { navigateToState, Layout, CYTBottomNavigation } from "./layout.js";
import { CYTCard } from "./listcard.js";
import firebase from "./CYTFirebase.js";
import { Alert, AlertTitle } from "@material-ui/lab";

import {
  CellMeasurer,
  CellMeasurerCache,
  createMasonryCellPositioner,
  Masonry,
  AutoSizer
} from "react-virtualized";

import { distance } from "./geo.js";

const dataStore = require("./dataStore.js");

export class CYTtable extends React.Component {
  renderCYTRow(pl, styles) {
    return (
      <CYTCard
        provider={pl}
        style={styles}
        liked={this.state.likes[pl.id] === "like"}
        onCategoryClick={this.handleCategoryClick}
        onClick={e => this.handleClick(e, pl.id)}
        selectedCategories={this.state.categories}
        currentGeopos={this.state.currentGeopos}
      />
    );
  }

  handleSearch(e) {
    var st = { ...this.state };
    st.query = e.target.value !== "" ? e.target.value : null;
    this.setState(st);
    navigateToState(st);
  }

  handleCategoryClick(e, categoryName) {
    categoryName = categoryName.toLowerCase();
    var currCategories = this.state.categories.slice();
    if (this.state.categories.includes(categoryName)) {
      // remove from filterd cats
      currCategories = currCategories.filter(cat => cat !== categoryName);
    } else {
      // add to filtered cats
      currCategories.push(categoryName);
    }
    var st = { ...this.state };
    st.categories = currCategories;
    this.setState(st);
    navigateToState(st);
  }

  handleClick(e, id) {
    if (firebase.auth().currentUser === null) {
      firebase.analytics().logEvent("unauthenticated_like_attempt");
      return alert("Primero identificate :)");
    }
    const likes = { ...this.state.likes };

    if (likes[id] === "like") {
      likes[id] = "";
      firebase.analytics().logEvent("unlike", { provider: id });
    } else {
      likes[id] = "like";
      firebase.analytics().logEvent("like", { provider: id });
    }

    this.setState({ likes: likes });

    // save like/dislike in reactions/USER_ID/reactions/PROVIDER_ID/{reaction: like}
    const data = { reaction: likes[id] };
    firebase
      .firestore()
      .collection("users")
      .doc(firebase.auth().currentUser.uid)
      .collection("reactions")
      .doc(id)
      .set(data);
  }

  constructor(props) {
    super(props);
    const prefilteredCategories =
      props.categories && props.categories.toLowerCase().split(",");
    const queryParams = queryString.parse(props.location.search);

    this.state = {
      likes: {},
      providers: [],
      otherUserId: props.otherUserId,
      otherUser: null,
      otherUserLikes: {},
      sortBy: "distance",
      query: queryParams["q"],
      categories: prefilteredCategories || [],
      currentGeopos: {},
      user: null
    };

    var that = this;
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        console.debug("Firebase AuthState Changed", user);
        that.onLogin(user);
        console.log("Retrieve reactions");
        that.retrieveReactions(user, newState => {
          const oldState = { ...that.state.likes };
          console.log("RetrieveReactions for Main User:", newState);
          var st = { ...that.state };
          st.likes = { ...oldState, ...newState };
          that.setState(st);
        });
      }
    });

    this.handleCategoryClick = this.handleCategoryClick.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleSearchThrottled = throttle(this.handleSearch, 100);
    this.updateCurrentGeopos = this.updateCurrentGeopos.bind(this);
    this.setSortByAlpha = this.setSortByAlpha.bind(this);
    this.setSortByDistance = this.setSortByDistance.bind(this);
    this.setFilterOnlyFavorites = this.setFilterOnlyFavorites.bind(this);
    this.updateConfig = this.updateConfig.bind(this);
    this.updateProviders();
    if (this.state.otherUserId) {
      this.retrieveOtherUserReactions(this.state.otherUserId);
    }
    if (props.otherUserVanityURL) {
      this.retrieveOtherUserReactionsByVanityURL(props.otherUserVanityURL);
    }

    this.cache = new CellMeasurerCache({
      fixedWidth: true
    });
  }

  updateConfig(data) {
    if (data.vanity_url) {
      var st = { ...this.state };
      st.user.vanity_url = data.vanity_url;
      this.setState(st);
    }
    firebase
      .firestore()
      .collection("users")
      .doc(firebase.auth().currentUser.uid)
      .set(data, { merge: true });
  }

  updateProviders() {
    dataStore.getProviders().then(providers => {
      var st = { ...this.state };
      st.providers = providers;
      this.setState(st);
    });
  }

  onLogin(user) {
    firebase
      .firestore()
      .collection("users")
      .doc(firebase.auth().currentUser.uid)
      .get()
      .then(userDoc => {
        const user = { vanity_url: userDoc.get("vanity_url") };
        if (user.vanity_url === undefined) {
          user.vanity_url = firebase.auth().currentUser.uid;
          this.updateConfig({ vanity_url: user.vanity_url });
        }

        console.log("User from ", firebase.auth().currentUser.uid, user);
        var st = { ...this.state };
        st.user = user;
        this.setState(st);
      });
  }

  retrieveOtherUserReactionsByVanityURL(vanityURL) {
    var that = this;
    firebase
      .firestore()
      .collection("users")
      .where("vanity_url", "==", vanityURL)
      .get()
      .then(snapshot => {
        if (snapshot.size === 0) {
          console.log("Can't find vanityURL", vanityURL);
          return;
        }
        const userDoc = snapshot.docs[0];

        var userId;
        if (userDoc) {
          userId = userDoc.ref.path.split("/")[1];
        }
        console.log(
          "user from vanityurl",
          vanityURL,
          snapshot,
          userDoc.ref.path,
          userId
        );

        const st = { ...that.state };
        st.otherUserId = userId;
        st.otherUser = { uid: userId, name: vanityURL };
        that.setState(st);
        that.retrieveOtherUserReactions(userId);
      });
  }
  retrieveOtherUserReactions(otherUserId) {
    var that = this;
    this.retrieveReactions({ uid: otherUserId }, otherUserReactions => {
      const st = { ...that.state };
      st.otherUserLikes = { ...st.otherUserLikes, ...otherUserReactions };
      console.log("Setting state for otherUserLikes:", st.otherUserLikes);
      that.setState(st);
    });
  }

  retrieveReactions(user, callback) {
    var query = firebase.firestore().collection(`users/${user.uid}/reactions/`);
    query.onSnapshot(snapshot => {
      const newState = {};
      snapshot.docChanges().forEach(change => {
        newState[change.doc.id] = change.doc.data().reaction;
      });
      console.log("RetrieveReactions for User:", user.uid, newState);
      callback(newState);
    });
  }

  componentDidMount() {
    this.trackCurrentGeopos();
  }

  updateCurrentGeopos(position) {
    const latitude = position.coords.latitude;
    const longitude = position.coords.longitude;
    var st = { ...this.state };
    st.currentGeopos = { lat: latitude, lon: longitude };
    this.setState(st);
  }

  trackCurrentGeopos() {
    var that = this;
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        that.updateCurrentGeopos,
        console.log
      );
    }
  }

  render() {
    var that = this;
    const currentGeopos = this.state.currentGeopos;
    var allProviders = this.state.providers;
    var afterOtherUserFilter;

    const afterTextSearchProviders = search(this.state.query, allProviders);

    if (this.state.otherUserId) {
      console.log("Other user likes: ", this.state.otherUserLikes);
      afterOtherUserFilter = afterTextSearchProviders.filter(oProvider => {
        return this.state.otherUserLikes[oProvider.id];
      });
    } else {
      afterOtherUserFilter = afterTextSearchProviders;
    }

    var afterOnlyFavorites = afterOtherUserFilter;
    if (this.state.filterOnlyFavorites) {
      afterOnlyFavorites = afterOnlyFavorites.filter(
        provider => this.state.likes[provider.id] === "like"
      );
    }

    const afterCategories = afterOnlyFavorites.filter(provider => {
      // has any of the filterd categories?
      if (this.state.categories.length === 0) {
        return true;
      } else if (
        provider.categories &&
        that.state.categories.filter(value =>
          provider.categories.includes(value.toLowerCase())
        ).length === that.state.categories.length
      ) {
        // array intersection
        return true;
      } else {
        return false;
      }
    });

    const afterGeofilter = afterCategories;

    var afterSort;
    if (this.state.sortBy === "distance") {
      afterSort = afterGeofilter.sort((raw_p1, raw_p2) => {
        var d1 = 99999,
          d2 = 99999;

        if (currentGeopos && raw_p1.geopoint) {
          const p1 = {
            lat: raw_p1.geopoint.latitude,
            lon: raw_p1.geopoint.longitude
          };
          d1 = distance(currentGeopos.lat, currentGeopos.lon, p1.lat, p1.lon);
        }
        if (currentGeopos && raw_p2.geopoint) {
          const p2 = {
            lat: raw_p2.geopoint.latitude,
            lon: raw_p2.geopoint.longitude
          };
          d2 = distance(currentGeopos.lat, currentGeopos.lon, p2.lat, p2.lon);
        }

        return d1 - d2;
      });
    } else if (this.state.sortBy === "alpha") {
      afterSort = afterGeofilter.sort((a, b) => {
        var nameA = a.name.toUpperCase(); // ignore upper and lowercase
        var nameB = b.name.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        // names must be equal
        return 0;
      });
    }

    const cellRenderer = function ({ index, key, parent, style }) {
      const pl = afterSort[index];
      if (!pl) {
        return null;
      }
      return (
        <CellMeasurer
          cache={that.cache}
          index={index}
          key={pl.id}
          parent={parent}
        >
          {that.renderCYTRow(pl, { ...style, ...{ width: that.columnWidth } })}
        </CellMeasurer>
      );
    };

    const renderMasonry = function ({ width, height }) {
      let colWidth, colSpacer, currColCount;
      colWidth = width;
      colSpacer = 1;
      currColCount = 1;
      that.columnWidth = colWidth;

      if (!that.cellPositioner) {
        that.cellPositioner = createMasonryCellPositioner({
          cellMeasurerCache: that.cache,
          columnCount: currColCount,
          columnWidth: colWidth,
          spacer: colSpacer
        });
      } else if (currColCount !== that.lastColCount) {
        that.cellPositioner.reset({
          columnCount: currColCount,
          columnWidth: colWidth,
          spacer: colSpacer
        });
        that.lastColCount = currColCount;
      }

      return (
        <Masonry
          cellCount={afterSort.length}
          cellMeasurerCache={that.cache}
          cellPositioner={that.cellPositioner}
          cellRenderer={cellRenderer}
          height={height}
          width={width}
        />
      );
    };

    return (
      <Layout
        firebase={firebase}
        query={this.state.query}
        handleSearch={this.handleSearch}
        otherUser={this.state.otherUser}
        onLogin={this.onLogin}
        updateConfig={this.updateConfig}
        user={this.state.user}
      >
        <Alert severity="info">
          <AlertTitle>Bienvenido</AlertTitle>
          ¿Tenés un proveedor de insumos para cocinar o bebidas genial? 
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://airtable.com/shrFln34CA7D2rs9Q"
          >
            compartilo acá
          </a>
        </Alert>
        <AutoSizer overscanByPixels={500}>{renderMasonry}</AutoSizer>
        <CYTBottomNavigation
          sortByDistance={this.setSortByDistance}
          onlyFavorites={this.setFilterOnlyFavorites}
          sortByAlpha={this.setSortByAlpha}
        />
      </Layout>
    );
  }

  setSortByDistance() {
    const st = { ...this.state };
    st.sortBy = "distance";
    this.setState(st);
  }

  setSortByAlpha() {
    const st = { ...this.state };
    st.sortBy = "alpha";
    this.setState(st);
  }

  setFilterOnlyFavorites() {
    const st = { ...this.state };
    st.filterOnlyFavorites = st.filterOnlyFavorites ? false : true;
    this.setState(st);
  }
}

function search(rawNeedle, haystack) {
  if (!rawNeedle) {
    return haystack;
  }
  const needle = rawNeedle.toLowerCase();

  return haystack.filter(e => {
    return (
      strInStr(needle, e.name) ||
      strInStr(needle, e.what) ||
      e.categories.find(cat => strInStr(needle, cat))
    );
  });
}

function strInStr(rawNeedle, rawHaystack) {
  if (!rawHaystack || !rawNeedle) {
    return false;
  }
  const needle = rawNeedle
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();
  const haystack = rawHaystack
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();
  return haystack.indexOf(needle) > -1;
}
